(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const announce = text => { const el = $('#LiveRegion'); if (el) el.textContent = text; };
  const storefrontRoute = name => {
    const route = window.theme?.routes?.[name];
    if (!route) throw new Error(`Route Shopify indisponible : ${name}`);
    return route;
  };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const escapeHtml = value => { const el = document.createElement('span'); el.textContent = value || ''; return el.innerHTML; };
  const cartPropertiesMarkup = item => {
    const properties = Object.entries(item?.properties || {}).filter(([name, value]) => value && !name.startsWith('_'));
    if (!properties.length) return '';
    return `<div class="cart-item__properties">${properties.map(([name, value]) => `<small><strong>${escapeHtml(name)} :</strong> ${escapeHtml(String(value))}</small>`).join('')}</div>`;
  };
  const SEARCH_UNIVERSES = ['consommables', 'carrosserie', 'mecanique'];
  const SEARCH_UNIVERSE_LABELS = {
    consommables: 'Consommables carrosserie',
    carrosserie: 'Pièces carrosserie',
    mecanique: 'Pièces mécaniques'
  };
  const SEARCH_UNIVERSE_TAGS = {
    consommables: 'univers-consommables',
    carrosserie: 'univers-carrosserie',
    mecanique: 'univers-mecanique'
  };
  const getSearchUniverse = () => {
    const universe = document.documentElement.dataset.pfUniverse;
    return SEARCH_UNIVERSES.includes(universe) ? universe : 'consommables';
  };
  const normalizeProductTags = tags => {
    if (Array.isArray(tags)) return tags.map(tag => String(tag).trim().toLowerCase()).filter(Boolean);
    return String(tags || '').split(',').map(tag => tag.trim().toLowerCase()).filter(Boolean);
  };
  const productMatchesUniverse = (tags, universe = getSearchUniverse()) => {
    const normalized = normalizeProductTags(tags);
    const universeTags = Object.values(SEARCH_UNIVERSE_TAGS);
    if (universe === 'consommables') {
      return normalized.includes(SEARCH_UNIVERSE_TAGS.consommables) || !normalized.some(tag => universeTags.includes(tag));
    }
    return normalized.includes(SEARCH_UNIVERSE_TAGS[universe]);
  };
  const syncUniverseSearch = (universe = getSearchUniverse()) => {
    const activeUniverse = SEARCH_UNIVERSES.includes(universe) ? universe : 'consommables';
    const label = SEARCH_UNIVERSE_LABELS[activeUniverse];
    $$('[data-search-universe-input]').forEach(input => { input.value = activeUniverse; });
    $$('[data-universe-search-field]').forEach(input => {
      input.placeholder = `Rechercher dans ${label.toLowerCase()}…`;
      input.setAttribute('aria-label', `Rechercher dans l’univers ${label}`);
    });
    $$('[data-search-universe-label]').forEach(element => {
      element.textContent = `Recherche · ${label}`;
    });

    const page = $('[data-universe-search-page]');
    if (!page) return;
    let visibleProducts = 0;
    $$('[data-search-result][data-search-object-type="product"]', page).forEach(result => {
      const visible = productMatchesUniverse(result.dataset.searchTags, activeUniverse);
      result.hidden = !visible;
      if (visible) visibleProducts += 1;
    });
    const count = $('[data-search-visible-count]', page);
    if (count) {
      const total = Number(page.dataset.searchTotal || visibleProducts);
      const pagination = $('[data-search-pagination]', page);
      const currentPage = Number(pagination?.dataset.searchCurrentPage || 1);
      const pages = Number(pagination?.dataset.searchPages || 1);
      count.textContent = pages > 1
        ? `${visibleProducts} affiché${visibleProducts > 1 ? 's' : ''} sur cette page · page ${currentPage}/${pages} · ${total} résultat${total > 1 ? 's' : ''}`
        : `${visibleProducts} produit${visibleProducts > 1 ? 's' : ''} dans cet univers`;
    }
    const universeEmpty = $('[data-search-universe-empty]', page);
    if (universeEmpty) {
      const showEmpty = activeUniverse !== 'consommables' && visibleProducts === 0;
      universeEmpty.hidden = !showEmpty;
      $('[data-search-empty-title]', universeEmpty)?.replaceChildren(
        document.createTextNode(`Le catalogue ${label.toLowerCase()} arrive bientôt`)
      );
    }
    const nativeEmpty = $('[data-search-native-empty]', page);
    if (nativeEmpty) nativeEmpty.hidden = activeUniverse !== 'consommables';
    const pagination = $('[data-search-pagination]', page);
    if (pagination) pagination.hidden = activeUniverse !== 'consommables' && visibleProducts === 0;
  };
  syncUniverseSearch();
  document.addEventListener('profinish:universe-change', event => syncUniverseSearch(event.detail?.universe));
  document.addEventListener('shopify:section:load', () => syncUniverseSearch());

  class Drawer extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
    }
    open() { this.setAttribute('open', ''); document.body.classList.add('is-locked'); this.querySelector('[data-close]')?.focus(); }
    close() { this.removeAttribute('open'); document.body.classList.remove('is-locked'); }
  }
  customElements.define('pf-drawer', Drawer);

  const openDrawer = id => document.getElementById(id)?.open();
  $$('[data-open-drawer]').forEach(button => button.addEventListener('click', async event => {
    event.preventDefault();
    const drawerId = button.dataset.openDrawer;
    if (drawerId !== 'CartDrawer') {
      openDrawer(drawerId);
      return;
    }
    button.setAttribute('aria-busy', 'true');
    try {
      await refreshCart(true);
    } catch {
      openDrawer('CartDrawer');
      announce('Le panier n’a pas pu être actualisé.');
    } finally {
      button.removeAttribute('aria-busy');
    }
  }));

  async function refreshCart(open = false, cartData = null) {
    const cart = cartData || await fetch(storefrontRoute('cart')).then(r => r.json());
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const body = $('[data-cart-body]');
    if (body) body.innerHTML = cart.items.length ? cart.items.map((item, i) => `<div class="cart-item"><img src="${item.image || ''}&width=160" alt=""><div class="cart-item__content"><a href="${item.url}">${escapeHtml(item.product_title)}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}${cartPropertiesMarkup(item)}<div class="price">${money(item.final_line_price)}</div><div class="cart-quantity"><button type="button" data-cart-decrease data-cart-key="${item.key}" aria-label="Retirer une unité">−</button><label class="visually-hidden" for="DrawerQty-${i}">Quantité</label><input id="DrawerQty-${i}" type="number" min="0" value="${item.quantity}" readonly data-cart-quantity="${item.key}"><button type="button" data-cart-increase data-cart-key="${item.key}" aria-label="Ajouter une unité">+</button></div></div><button class="cart-item__remove" type="button" data-cart-remove="${item.key}" aria-label="Supprimer ${escapeHtml(item.product_title)}">×</button></div>`).join('') : '<p>Votre panier est vide.</p>';
    $('[data-cart-subtotal]')?.replaceChildren(document.createTextNode(money(cart.total_price)));
    syncCartPage(cart);
    updateShipping(cart.total_price);
    bindCartActions();
    if (open) openDrawer('CartDrawer');
    return cart;
  }
  function updateShipping(total) {
    $$('[data-shipping-progress]').forEach(el => {
      const threshold = Number(el.dataset.shippingThreshold || 0) * 100;
      const pct = threshold ? Math.min(100, total / threshold * 100) : 100;
      const bar = $('.shipping-progress__bar', el);
      bar?.style.setProperty('--progress', `${pct}%`);
      el.dataset.complete = String(pct >= 100);
      const text = $('[data-shipping-text]', el);
      if (text) text.textContent = pct >= 100 ? 'Livraison offerte' : `Encore ${money(threshold - total)} pour la livraison offerte`;
    });
  }
  function syncCartPage(cart) {
    const page = $('[data-cart-page]');
    if (!page) return;
    if (!cart.items.length) {
      window.location.reload();
      return;
    }
    $$('[data-cart-page-item]', page).forEach(row => {
      const item = cart.items.find(entry => entry.key === row.dataset.cartPageItem);
      if (!item) {
        row.remove();
        return;
      }
      $('[data-cart-quantity]', row).value = item.quantity;
      $('[data-cart-line-price]', row)?.replaceChildren(document.createTextNode(money(item.final_line_price)));
    });
    $('[data-cart-page-subtotal]', page)?.replaceChildren(document.createTextNode(money(cart.total_price)));
    const discounts = $('[data-cart-discounts]', page);
    if (discounts) discounts.innerHTML = (cart.cart_level_discount_applications || []).map(discount => `<p>${escapeHtml(discount.title)} −${money(discount.total_allocated_amount)}</p>`).join('');
  }
  function bindCartActions() {
    $$('[data-cart-decrease]').forEach(button => button.onclick = () => {
      const input = $('[data-cart-quantity]', button.closest('.cart-quantity'));
      changeCart(button.dataset.cartKey, Math.max(0, Number(input?.value || 0) - 1), button);
    });
    $$('[data-cart-increase]').forEach(button => button.onclick = () => {
      const input = $('[data-cart-quantity]', button.closest('.cart-quantity'));
      changeCart(button.dataset.cartKey, Number(input?.value || 0) + 1, button);
    });
    $$('[data-cart-remove]').forEach(el => el.onclick = () => changeCart(el.dataset.cartRemove, 0));
  }
  async function changeCart(id, quantity, source = null) {
    const control = source?.closest('.cart-quantity');
    control?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(storefrontRoute('cartChange'), { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id, quantity }) });
      if (!response.ok) throw new Error('Impossible de modifier la quantité.');
      const cart = await response.json();
      await refreshCart(false, cart);
      announce(quantity > 0 ? `Quantité mise à jour : ${quantity}` : 'Produit retiré du panier');
    } catch (error) {
      announce(error.message);
    } finally {
      control?.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('[data-product-add-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.cartSubmitPending === 'true') return;
    form.dataset.cartSubmitPending = 'true';
    const submit = $('[type="submit"]', form);
    submit?.setAttribute('aria-busy','true');
    submit?.setAttribute('aria-disabled','true');
    try {
      const res = await fetch(storefrontRoute('cartAdd'), { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      if (!res.ok) throw new Error((await res.json()).description);
      await refreshCart(true); announce('Produit ajouté au panier');
      document.dispatchEvent(new CustomEvent('profinish:product-added', { detail: { form } }));
    } catch (err) {
      announce(err.message);
    } finally {
      delete form.dataset.cartSubmitPending;
      submit?.removeAttribute('aria-busy');
      submit?.removeAttribute('aria-disabled');
    }
  });

  const complementModal = $('[data-complement-modal]');
  if (complementModal) {
    const closeComplementModal = () => complementModal.open && complementModal.close();
    $$('[data-complement-close]', complementModal).forEach(button => button.addEventListener('click', closeComplementModal));
    complementModal.addEventListener('click', event => { if (event.target === complementModal) closeComplementModal(); });
    document.addEventListener('profinish:product-added', event => {
      const triggerVariantId = $('[name="id"]', event.detail?.form)?.value;
      let visibleCards = 0;
      $$('[data-complement-card]', complementModal).forEach(card => {
        const matches = !card.dataset.complementTriggerId || card.dataset.complementTriggerId === triggerVariantId;
        card.hidden = !matches;
        if (matches) visibleCards += 1;
      });
      if (!visibleCards) return;
      if (typeof complementModal.showModal === 'function') complementModal.showModal();
      else complementModal.setAttribute('open', '');
    });
    $$('[data-complement-add]', complementModal).forEach(button => button.addEventListener('click', async () => {
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(storefrontRoute('cartAdd'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Ajout impossible.');
        closeComplementModal(); await refreshCart(true); announce('Produit complémentaire ajouté au panier');
      } catch (error) { announce(error.message); }
      finally { button.removeAttribute('aria-busy'); }
    }));
  }

  class PfSlider extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this); this.index = 0;
      $('[data-next]', this)?.addEventListener('click', () => this.show(this.index + 1));
      $('[data-prev]', this)?.addEventListener('click', () => this.show(this.index - 1));
      $$('[data-dot]', this).forEach((d,i) => d.addEventListener('click', () => this.show(i)));
      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.speed || 6000));
        this.addEventListener('mouseenter', () => clearInterval(this.timer), {once:true});
      }
    }
    show(i) { if (!this.slides.length) return; this.slides[this.index]?.classList.remove('is-active'); this.index=(i+this.slides.length)%this.slides.length; this.slides[this.index].classList.add('is-active'); $$('[data-dot]',this).forEach((d,j)=>d.setAttribute('aria-current',String(j===this.index))); }
  }
  customElements.define('pf-slider', PfSlider);

  let closeActiveSelect = null;
  function enhanceSelect(select) {
    if (select.dataset.pfSelectReady === 'true' || select.multiple || Number(select.size) > 1) return;
    select.dataset.pfSelectReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'pf-select';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    select.classList.add('pf-select__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pf-select__trigger';
    trigger.id = `${select.id || `PfSelect-${Math.random().toString(36).slice(2)}`}-Trigger`;
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span></span><svg viewBox="0 0 12 8" aria-hidden="true"><path d="m1 1 5 5 5-5"/></svg>';
    wrapper.appendChild(trigger);

    const menu = document.createElement('div');
    menu.className = 'pf-select__menu';
    menu.id = `${trigger.id}-Menu`;
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    trigger.setAttribute('aria-controls', menu.id);
    wrapper.appendChild(menu);

    if (select.id) {
      const label = $$('label').find(item => item.htmlFor === select.id);
      if (label) label.htmlFor = trigger.id;
    }

    const buttons = [];
    const selectHost = select.closest('.vehicle-finder');
    const panelHost = select.closest('.universe-home__panel');

    const sync = () => {
      const selected = select.selectedOptions[0] || select.options[0];
      $('span', trigger).textContent = selected?.textContent || '';
      trigger.disabled = select.disabled;
      buttons.forEach((button, index) => button.setAttribute('aria-selected', String(index === select.selectedIndex)));
    };
    const close = (restoreFocus = false) => {
      menu.hidden = true;
      wrapper.classList.remove('is-open');
      selectHost?.classList.remove('has-open-select');
      panelHost?.classList.remove('has-open-select');
      trigger.setAttribute('aria-expanded', 'false');
      if (closeActiveSelect === close) closeActiveSelect = null;
      if (restoreFocus) trigger.focus();
    };
    const open = () => {
      if (trigger.disabled) return;
      closeActiveSelect?.();
      menu.hidden = false;
      wrapper.classList.add('is-open');
      selectHost?.classList.add('has-open-select');
      panelHost?.classList.add('has-open-select');
      trigger.setAttribute('aria-expanded', 'true');
      closeActiveSelect = close;
      const activeIndex = Math.max(0, select.selectedIndex);
      const activeButton = buttons[activeIndex] || buttons[0];
      if (activeIndex === 0) {
        menu.scrollTop = 0;
      } else if (activeButton) {
        menu.scrollTop = Math.max(0, activeButton.offsetTop - (menu.clientHeight - activeButton.offsetHeight) / 2);
      }
      activeButton?.focus({ preventScroll: true });
    };
    const choose = index => {
      const option = select.options[index];
      if (!option || option.disabled) return;
      const changed = select.selectedIndex !== index;
      select.selectedIndex = index;
      sync();
      close(true);
      if (changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    const bindButton = (button, index) => {
      button.addEventListener('click', () => choose(index));
      button.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index + (event.key === 'ArrowDown' ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        next = Math.max(0, Math.min(buttons.length - 1, next));
        while (buttons[next]?.disabled && next !== index) next += next > index ? 1 : -1;
        buttons[next]?.focus();
      });
    };
    const rebuild = () => {
      close();
      buttons.splice(0);
      menu.replaceChildren();
      menu.scrollTop = 0;
      [...select.options].forEach((option, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pf-select__option';
        button.dataset.index = index;
        button.setAttribute('role', 'option');
        button.disabled = option.disabled;
        button.hidden = option.hidden;
        button.innerHTML = '<span></span><b aria-hidden="true">✓</b>';
        $('span', button).textContent = option.textContent;
        bindButton(button, index);
        menu.appendChild(button);
        buttons.push(button);
      });
      sync();
    };

    trigger.addEventListener('click', () => menu.hidden ? open() : close());
    trigger.addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        open();
      }
    });
    wrapper.addEventListener('focusout', event => {
      if (!wrapper.contains(event.relatedTarget)) close();
    });
    select.pfRebuild = rebuild;
    select.addEventListener('change', sync);
    rebuild();
  }
  const initCustomSelects = (root = document) => $$('select', root).forEach(enhanceSelect);
  initCustomSelects();
  document.addEventListener('click', event => {
    if (closeActiveSelect && !event.target.closest('.pf-select')) closeActiveSelect();
  });
  document.addEventListener('shopify:section:load', event => initCustomSelects(event.target));

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.panel = $('.predictive-search__panel', this);
      this.abortController = null;
      this.searchSequence = 0;
      this.productTagCache = new Map();
      this.input?.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 180);
      });
      this.input?.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.close(); });
    }
    escape(value = '') { const el = document.createElement('span'); el.textContent = value; return el.innerHTML; }
    async getProductTags(product) {
      const inlineTags = normalizeProductTags(product.tags);
      if (inlineTags.length) return inlineTags;
      const cacheKey = product.url || product.handle || product.id;
      if (this.productTagCache.has(cacheKey)) return this.productTagCache.get(cacheKey);
      const tagRequest = (async () => {
        try {
          const productUrl = new URL(product.url, window.location.origin);
          productUrl.pathname = `${productUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '')}.js`;
          productUrl.search = '';
          const response = await fetch(productUrl.toString());
          if (!response.ok) throw new Error('Produit introuvable');
          const data = await response.json();
          return normalizeProductTags(data.tags);
        } catch (error) {
          return [];
        }
      })();
      this.productTagCache.set(cacheKey, tagRequest);
      return tagRequest;
    }
    async filterProductsByUniverse(products, universe) {
      const matches = await Promise.all(products.map(async product => {
        const tags = await this.getProductTags(product);
        return productMatchesUniverse(tags, universe);
      }));
      return products.filter((product, index) => matches[index]);
    }
    async search(term) {
      const sequence = ++this.searchSequence;
      if (term.length < 2) {
        this.abortController?.abort();
        return this.close();
      }
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.panel.hidden = false;
      this.panel.innerHTML = '<div class="predictive-search__loading">Recherche en cours…</div>';
      this.input.setAttribute('aria-expanded', 'true');
      try {
        const root = window.theme?.routes?.root || window.Shopify?.routes?.root || '/';
        const fields = 'title,body,product_type,tag,variants.barcode,variants.sku,variants.title,vendor,author';
        const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=${encodeURIComponent(fields)}`;
        const data = await fetch(url, { signal: this.abortController.signal }).then(r => r.json());
        const results = data.resources.results;
        const universe = getSearchUniverse();
        const products = await this.filterProductsByUniverse(results.products || [], universe);
        if (sequence !== this.searchSequence) return;
        const secondary = [...(results.collections || []), ...(results.pages || []), ...(results.articles || [])];
        if (!products.length && !secondary.length) {
          this.panel.innerHTML = `<div class="predictive-search__empty">Aucun résultat dans l’univers ${this.escape(SEARCH_UNIVERSE_LABELS[universe].toLowerCase())} pour « ${this.escape(term)} »</div>`;
          return;
        }
        const productHtml = products.map(p => `<a class="predictive-product" href="${p.url}" role="option">${p.featured_image?.url ? `<img src="${p.featured_image.url}&width=130" alt="">` : '<span class="predictive-product__placeholder"></span>'}<span><small>${this.escape(p.vendor || p.type || 'Produit')}</small><strong>${this.escape(p.title)}</strong><b>${this.escape(p.price || '')}</b></span></a>`).join('');
        const otherHtml = secondary.length ? `<div class="predictive-links"><span>Suggestions</span>${secondary.map(item => `<a href="${item.url}" role="option">${this.escape(item.title)} <b>→</b></a>`).join('')}</div>` : '';
        this.panel.innerHTML = `<div class="predictive-search__head"><span>${this.escape(SEARCH_UNIVERSE_LABELS[universe])}</span><a href="${root}search?q=${encodeURIComponent(term)}&type=product,page,article&options[prefix]=last&univers=${encodeURIComponent(universe)}">Tout afficher →</a></div><div class="predictive-search__body"><div class="predictive-products">${productHtml}</div>${otherHtml}</div>`;
      } catch (error) { if (error.name !== 'AbortError') this.close(); }
    }
    close() { if (!this.panel) return; this.panel.hidden = true; this.panel.innerHTML = ''; this.input?.setAttribute('aria-expanded', 'false'); }
  }
  customElements.define('predictive-search', PredictiveSearch);

  bindCartActions();

  $$('[data-quantity]').forEach(q => {
    const input = $('input', q);
    $('[data-minus]', q)?.addEventListener('click', () => input.value = Math.max(Number(input.min || 1), Number(input.value)-1));
    $('[data-plus]', q)?.addEventListener('click', () => input.value = Number(input.value)+1);
  });
  function applyProductVariant(form, variant) {
    if (!form || !variant) return;
    const hiddenId = $('[data-variant-id]', form);
    if (hiddenId) hiddenId.value = variant.id;
    const available = variant.available;
    const submit = $('.product-form__submit', form);
    submit.disabled = !available;
    submit.setAttribute('aria-disabled', String(!available));
    submit.classList.toggle('product-form__submit--soldout', !available);
    submit.textContent = available ? 'Ajouter au panier' : 'Produit épuisé';
    $$('button,input', $('[data-quantity]', form)).forEach(control => control.disabled = !available);
    $('[data-quantity]', form)?.classList.toggle('quantity--disabled', !available);
    $('.product-info')?.classList.toggle('product-info--soldout', !available);
    $('.shopify-payment-button')?.toggleAttribute('hidden', !available);
    const gallery = $('.product-gallery__main');
    const ribbon = $('.product-gallery__soldout', gallery);
    if (!available && !ribbon) gallery?.insertAdjacentHTML('afterbegin', '<span class="product-gallery__soldout">Victime de son succès</span>');
    if (available && ribbon) ribbon.remove();
    const stock = $('[data-product-stock]');
    if (stock) {
      stock.className = `product-stock product-stock--${available ? 'available' : 'soldout'}`;
      stock.innerHTML = available ? '<strong>En stock</strong> · Expédition selon disponibilité' : '<span aria-hidden="true">!</span><div><strong>Produit actuellement épuisé</strong><p>Le délai de réassort n’est pas encore confirmé.</p></div>';
    }
    $('[data-product-price]')?.replaceChildren(document.createTextNode(money(variant.price)));
    $('[data-product-sku]')?.replaceChildren(document.createTextNode(variant.sku || '—'));
    const stickyBar = $('[data-sticky-atc]');
    if (stickyBar) {
      stickyBar.dataset.stickyVariantId = String(variant.id);
      $('[data-sticky-sku]', stickyBar)?.replaceChildren(document.createTextNode(variant.sku || '—'));
      $('[data-sticky-price]', stickyBar)?.replaceChildren(document.createTextNode(money(variant.price)));
      const stickySubmit = $('[data-sticky-submit]', stickyBar);
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.setAttribute('aria-disabled', String(!available));
        stickySubmit.textContent = available ? 'Ajouter au panier' : 'Produit épuisé';
      }
    }
    const commercial = $('[data-product-commercial]');
    const commercialTemplate = $$('[data-variant-commercial-template]')
      .find(template => template.dataset.variantCommercialTemplate === String(variant.id));
    if (commercial && commercialTemplate) commercial.replaceChildren(commercialTemplate.content.cloneNode(true));
    if (window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  function initVariantPickers(root = document) {
    $$('[data-variant-picker]', root).forEach(picker => {
      if (picker.dataset.variantReady === 'true') return;
      picker.dataset.variantReady = 'true';
      const form = picker.closest('form');
      const variantsNode = $('[data-product-variants]', picker);
      if (!form || !variantsNode) return;
      let variants;
      try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
      const rows = $$('[data-option-position]', picker).filter(item => item.matches('fieldset'));

      const selectedValues = () => rows.map(row => $('[data-option-value]:checked', row)?.value || '');
      const findExactVariant = values => variants.find(variant => variant.options.every((value, index) => value === values[index]));
      const syncRadios = variant => {
        rows.forEach((row, index) => {
          const radio = $$('[data-option-value]', row).find(item => item.value === variant.options[index]);
          if (radio) radio.checked = true;
          $('[data-option-current]', row)?.replaceChildren(document.createTextNode(variant.options[index] || ''));
        });
      };
      const refreshStates = () => {
        const values = selectedValues();
        rows.forEach((row, rowIndex) => {
          $$('[data-option-value]', row).forEach(radio => {
            const candidate = [...values];
            candidate[rowIndex] = radio.value;
            const exact = findExactVariant(candidate);
            const label = radio.closest('.variant-value');
            label?.classList.toggle('is-soldout', Boolean(exact && !exact.available));
            label?.classList.toggle('is-alternative', !exact);
            radio.setAttribute('aria-label', `${radio.value}${exact && !exact.available ? ', épuisé' : ''}`);
          });
        });
      };

      $$('[data-option-value]', picker).forEach(radio => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          const rowIndex = Number(radio.dataset.optionPosition);
          const values = selectedValues();
          let variant = findExactVariant(values);
          if (!variant) {
            variant = variants
              .filter(item => item.options[rowIndex] === radio.value)
              .sort((a, b) => Number(b.available) - Number(a.available))[0];
            if (!variant) return;
            syncRadios(variant);
          } else {
            $('[data-option-current]', radio.closest('.variant-row'))?.replaceChildren(document.createTextNode(radio.value));
          }
          applyProductVariant(form, variant);
          refreshStates();
        });
      });
      const initial = variants.find(variant => String(variant.id) === String($('[data-variant-id]', form)?.value));
      if (initial) syncRadios(initial);
      refreshStates();
    });
  }
  initVariantPickers();
  document.addEventListener('shopify:section:load', event => initVariantPickers(event.target));

  function initStickyProductBars(root = document) {
    $$('[data-sticky-atc]', root).forEach(bar => {
      if (bar.dataset.stickyReady === 'true') return;
      bar.dataset.stickyReady = 'true';
      const form = $('[data-product-add-form]');
      const mainSubmit = $('.product-form__submit', form);
      const stickySubmit = $('[data-sticky-submit]', bar);
      if (!form || !mainSubmit || !stickySubmit) return;
      const mobile = window.matchMedia('(max-width: 760px)');
      let mainSubmitVisible = true;
      let impressionSent = false;
      const consentVisible = () => {
        const banner = $('#shopify-pc__banner');
        if (!banner) return false;
        const style = window.getComputedStyle(banner);
        return !banner.hidden && banner.getAttribute('aria-hidden') !== 'true'
          && style.display !== 'none' && style.visibility !== 'hidden';
      };
      const emit = action => document.dispatchEvent(new CustomEvent('profinish:cro', { detail: {
        component: 'sticky_add_to_cart',
        action,
        variantId: bar.dataset.stickyVariantId || '',
      } }));
      const updateVisibility = () => {
        const visible = mobile.matches && !mainSubmitVisible && !consentVisible();
        bar.hidden = !visible;
        if (visible && !impressionSent) { impressionSent = true; emit('impression'); }
      };
      const intersection = new IntersectionObserver(entries => {
        mainSubmitVisible = entries[0]?.isIntersecting !== false;
        updateVisibility();
      }, { threshold: 0.05 });
      intersection.observe(mainSubmit);
      mobile.addEventListener?.('change', updateVisibility);
      let observedConsent = null;
      const consentObserver = new MutationObserver(updateVisibility);
      const consentInsertionObserver = new MutationObserver(() => {
        const banner = $('#shopify-pc__banner');
        if (!banner || banner === observedConsent) return;
        observedConsent = banner;
        consentObserver.observe(banner, { childList: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden'] });
        updateVisibility();
      });
      const initialConsent = $('#shopify-pc__banner');
      if (initialConsent) {
        observedConsent = initialConsent;
        consentObserver.observe(initialConsent, { childList: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden'] });
      }
      consentInsertionObserver.observe(document.body, { subtree: true, childList: true });
      stickySubmit.addEventListener('click', () => {
        if (mainSubmit.disabled || form.dataset.cartSubmitPending === 'true') return;
        emit('click');
        form.requestSubmit(mainSubmit);
      });
      document.addEventListener('profinish:product-added', event => {
        if (event.detail?.form === form) bar.hidden = true;
      });
      updateVisibility();
    });
  }
  initStickyProductBars();
  document.addEventListener('shopify:section:load', event => initStickyProductBars(event.target));

  function initPaintConfigurators(root = document) {
    $$('[data-paint-configurator]', root).forEach(configurator => {
      if (configurator.dataset.paintReady === 'true') return;
      configurator.dataset.paintReady = 'true';
      const form = configurator.closest('form');
      const modes = $$('[data-paint-mode]', configurator);
      const panels = $$('[data-paint-panel]', configurator);
      const summary = $('[data-paint-summary]', configurator);
      const weightInput = $('[data-paint-weight-input]', configurator);
      const weightMinus = $('[data-paint-weight-minus]', configurator);
      const weightPlus = $('[data-paint-weight-plus]', configurator);

      const updateWeight = (direction = 0) => {
        if (!weightInput) return;
        const minimum = Number(weightInput.min) || 300;
        const step = Number(weightInput.step) || 100;
        const current = Number(weightInput.value) || minimum;
        const next = Math.max(minimum, current + (direction * step));
        weightInput.value = String(next);
        if (weightMinus) weightMinus.disabled = next <= minimum;
      };

      const updateSummary = mode => {
        if (!summary) return;
        if (mode === 'ral') {
          const value = $('[name="properties[Code RAL]"]', configurator)?.value.trim();
          summary.textContent = value ? `Teinte ${value.toUpperCase()}` : 'Code RAL à compléter';
          return;
        }
        const brand = $('[name="properties[Constructeur]"]', configurator)?.value;
        const code = $('[name="properties[Code couleur constructeur]"]', configurator)?.value.trim();
        summary.textContent = brand && code ? `${brand} · ${code.toUpperCase()}` : 'Référence constructeur à compléter';
      };

      const activate = mode => {
        panels.forEach(panel => {
          const active = panel.dataset.paintPanel === mode;
          panel.hidden = !active;
          $$('input, select, textarea', panel).forEach(field => {
            field.disabled = !active;
            if (field.dataset.paintCode !== undefined || field.tagName === 'SELECT') field.required = active;
          });
        });
        updateSummary(mode);
      };

      modes.forEach(mode => mode.addEventListener('change', () => {
        if (mode.checked) activate(mode.dataset.paintMode);
      }));
      weightMinus?.addEventListener('click', () => updateWeight(-1));
      weightPlus?.addEventListener('click', () => updateWeight(1));
      weightInput?.addEventListener('change', () => updateWeight());
      weightInput?.addEventListener('blur', () => updateWeight());
      $$('input, select', configurator).forEach(field => {
        field.addEventListener('input', () => updateSummary($('[data-paint-mode]:checked', configurator)?.dataset.paintMode || 'manufacturer'));
        if (field.dataset.paintCode !== undefined) field.addEventListener('blur', () => {
          field.value = field.value.trim().replace(/\s+/g, ' ').toUpperCase();
          updateSummary($('[data-paint-mode]:checked', configurator)?.dataset.paintMode || 'manufacturer');
        });
      });
      form?.addEventListener('submit', event => {
        const invalid = $$('input:invalid, select:invalid', configurator).find(field => !field.disabled);
        if (!invalid) return;
        event.preventDefault();
        invalid.reportValidity();
        invalid.focus();
      });
      updateWeight();
      activate($('[data-paint-mode]:checked', configurator)?.dataset.paintMode || 'manufacturer');
    });
  }
  initPaintConfigurators();
  document.addEventListener('shopify:section:load', event => initPaintConfigurators(event.target));
  $$('[data-gallery-thumb]').forEach(b => b.addEventListener('click', () => { const main=$(`#${b.dataset.galleryThumb}`); if(main){main.src=b.dataset.src; main.alt=b.dataset.alt||'';} }));

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initPremiumEffects(root = document) {
    if (reducedMotion) return;
    $$('.section-heading,.product-card,.pathway,.trust-item,.brand-item', root).forEach((el, index) => {
      if (el.dataset.revealReady) return;
      el.dataset.revealReady = 'true';
      el.classList.add('reveal');
      el.style.setProperty('--reveal-delay', `${Math.min(index % 5, 4) * 65}ms`);
    });
  }
  initPremiumEffects();
  if (!reducedMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealObserver.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -7% 0px', threshold: .08 });
    $$('[data-reveal-ready]').forEach(el => revealObserver.observe(el));
    document.addEventListener('shopify:section:load', e => {
      initPremiumEffects(e.target);
      $$('[data-reveal-ready]', e.target).forEach(el => revealObserver.observe(el));
    });
  }
  if (!reducedMotion) {
    $$('.product-card').forEach(card => card.addEventListener('pointermove', e => {
      const r = card.getBoundingClientRect();
      card.style.setProperty('--spot-x', `${e.clientX - r.left}px`);
      card.style.setProperty('--spot-y', `${e.clientY - r.top}px`);
    }));
  }

  if (matchMedia('(hover: hover) and (min-width: 991px)').matches) {
    $$('.nav details').forEach(details => {
      let closeTimer;
      details.addEventListener('mouseenter', () => { clearTimeout(closeTimer); details.open = true; });
      details.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => { details.open = false; }, 140); });
      details.addEventListener('focusin', () => { clearTimeout(closeTimer); details.open = true; });
      details.addEventListener('focusout', e => { if (!details.contains(e.relatedTarget)) details.open = false; });
    });
  }

  const whatsappMenu = $('#WhatsAppMenu');
  const setWhatsApp = open => {
    if (!whatsappMenu) return;
    whatsappMenu.hidden = !open;
    $$('[data-whatsapp-toggle]').forEach(button => button.setAttribute('aria-expanded', String(open)));
  };
  $$('[data-whatsapp-toggle]').forEach(button => button.addEventListener('click', e => {
    e.stopPropagation();
    setWhatsApp(whatsappMenu?.hidden);
  }));
  $('[data-whatsapp-close]')?.addEventListener('click', () => setWhatsApp(false));
  document.addEventListener('click', e => { if (whatsappMenu && !whatsappMenu.hidden && !whatsappMenu.contains(e.target)) setWhatsApp(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setWhatsApp(false); });

  class VehicleFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.vehicleFinderReady === 'true') return;
      this.dataset.vehicleFinderReady = 'true';
      this.storageKey = 'profinish.garage.carrosserie';
      this.legacyStorageKey = 'profinish.vehicle.carrosserie';
      this.garageLimit = 5;
      this.garage = [];
      this.mode = 'guided';
      this.form = $('[data-vehicle-form]', this);
      this.brand = $('[data-vehicle-brand]', this);
      this.model = $('[data-vehicle-model]', this);
      this.year = $('[data-vehicle-year]', this);
      this.plate = $('[data-vehicle-plate]', this);
      this.vin = $('[data-vehicle-vin]', this);
      this.remember = $('[data-vehicle-remember]', this);
      this.error = $('[data-vehicle-error]', this);
      this.result = $('[data-vehicle-result]', this);
      this.garageToggle = $('[data-garage-toggle]', this);
      this.garagePanel = $('[data-garage-panel]', this);
      this.garageClose = $('[data-garage-close]', this);
      this.garageList = $('[data-garage-list]', this);
      this.garageEmpty = $('[data-garage-empty]', this);
      this.garageCount = $('[data-garage-count]', this);
      this.garageLimitLabel = $('[data-garage-limit]', this);
      this.catalogStatus = $('[data-vehicle-catalog-status]', this);
      this.catalog = this.buildCatalog();

      this.populateBrands();
      this.syncModelOptions();
      this.brand?.addEventListener('change', () => this.syncModelOptions(true));
      this.model?.addEventListener('change', () => this.syncPeriodOptions(true));
      $$('[data-vehicle-mode]', this).forEach(button => {
        button.addEventListener('click', () => this.setMode(button.dataset.vehicleMode));
      });
      this.form?.addEventListener('submit', event => {
        event.preventDefault();
        this.submit();
      });
      this.garageToggle?.addEventListener('click', () => this.toggleGarage());
      this.garageClose?.addEventListener('click', () => this.closeGarage(true));
      this.garageList?.addEventListener('click', event => {
        const useButton = event.target.closest('[data-garage-use]');
        const deleteButton = event.target.closest('[data-garage-delete]');
        if (useButton) this.restoreVehicle(this.garage[Number(useButton.dataset.garageUse)]);
        if (deleteButton) this.removeVehicle(Number(deleteButton.dataset.garageDelete));
      });
      document.addEventListener('click', event => {
        if (!this.garagePanel?.hidden && !this.garagePanel.contains(event.target) && !this.garageToggle?.contains(event.target)) {
          this.closeGarage();
        }
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.garagePanel?.hidden) this.closeGarage(true);
      });
      $('[data-vehicle-edit]', this)?.addEventListener('click', () => {
        this.result.hidden = true;
        (this.mode === 'guided' ? this.brand : this.plate)?.focus();
      });
      this.plate?.addEventListener('input', () => {
        this.plate.value = this.plate.value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
      });
      this.vin?.addEventListener('input', () => {
        this.vin.value = this.vin.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
      });
      this.loadGarage();
    }

    normalizeCatalogKey(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    buildCatalog() {
      const sources = Array.isArray(window.ProFinishVehicleSources) ? window.ProFinishVehicleSources : [];
      const brandMap = new Map();
      sources.forEach(source => {
        if (!source?.id || !Array.isArray(source.brands)) return;
        source.brands.forEach(sourceBrand => {
          const brandKey = this.normalizeCatalogKey(sourceBrand.name);
          if (!brandKey) return;
          if (!brandMap.has(brandKey)) {
            brandMap.set(brandKey, { key: brandKey, name: sourceBrand.name, providers: {}, models: new Map() });
          }
          const brand = brandMap.get(brandKey);
          brand.providers[source.id] = sourceBrand.id;
          (sourceBrand.models || []).forEach(sourceModel => {
            const modelKey = this.normalizeCatalogKey(sourceModel.name);
            if (!modelKey) return;
            if (!brand.models.has(modelKey)) {
              brand.models.set(modelKey, { key: modelKey, name: sourceModel.name, providers: {}, periods: new Map() });
            }
            const model = brand.models.get(modelKey);
            model.providers[source.id] = sourceModel.id;
            (sourceModel.periods || []).forEach(sourcePeriod => {
              const periodKey = this.normalizeCatalogKey(sourcePeriod.name);
              if (!periodKey) return;
              if (!model.periods.has(periodKey)) {
                model.periods.set(periodKey, { key: periodKey, name: sourcePeriod.name, providers: {} });
              }
              model.periods.get(periodKey).providers[source.id] = sourcePeriod.id;
            });
          });
        });
      });

      const collator = new Intl.Collator('fr', { numeric: true, sensitivity: 'base' });
      const compare = (a, b) => collator.compare(a.name, b.name);
      const periodStart = name => {
        if (/^\s*-\s*\d{1,2}\/\d{4}/.test(name)) return 0;
        const date = String(name).match(/(\d{1,2})\/(\d{4})/);
        if (date) return Number(date[2]) * 12 + Number(date[1]);
        const year = String(name).match(/\b(19|20)\d{2}\b/);
        return year ? Number(year[0]) * 12 : Number.MAX_SAFE_INTEGER;
      };
      const comparePeriods = (a, b) => periodStart(a.name) - periodStart(b.name) || compare(a, b);
      const brands = [...brandMap.values()].map(brand => ({
        ...brand,
        models: [...brand.models.values()].map(model => ({
          ...model,
          periods: [...model.periods.values()].sort(comparePeriods)
        })).sort(compare)
      })).sort(compare);

      const modelCount = brands.reduce((total, brand) => total + brand.models.length, 0);
      const periodCount = brands.reduce(
        (total, brand) => total + brand.models.reduce((subtotal, model) => subtotal + model.periods.length, 0),
        0
      );
      if (this.catalogStatus) {
        this.catalogStatus.textContent = brands.length
          ? `${brands.length} marques · ${modelCount} modèles · ${periodCount.toLocaleString('fr-FR')} périodes`
          : 'Référentiel véhicules en cours de chargement';
      }
      return brands;
    }

    replaceOptions(select, placeholder, entries) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      fragment.appendChild(new Option(placeholder, ''));
      entries.forEach(entry => fragment.appendChild(new Option(entry.name, entry.key)));
      select.replaceChildren(fragment);
      select.pfRebuild?.();
    }

    populateBrands() {
      this.replaceOptions(this.brand, 'Sélectionner la marque', this.catalog);
      if (this.brand) this.brand.disabled = false;
    }

    currentBrand() {
      return this.catalog.find(brand => brand.key === this.brand?.value);
    }

    currentModel() {
      return this.currentBrand()?.models.find(model => model.key === this.model?.value);
    }

    selectedText(select) {
      return select?.selectedOptions?.[0]?.textContent?.trim() || '';
    }

    syncModelOptions(reset = false) {
      if (!this.model) return;
      const brand = this.currentBrand();
      const models = brand?.models || [];
      this.replaceOptions(this.model, 'Sélectionner le modèle', models);
      this.model.disabled = !this.brand?.value;
      if (reset || !models.some(model => model.key === this.model.value)) this.model.value = '';
      this.syncPeriodOptions(true);
      this.model.pfRebuild?.();
    }

    syncPeriodOptions(reset = false) {
      if (!this.year) return;
      const periods = this.currentModel()?.periods || [];
      const canChoose = Boolean(this.model?.value);
      const placeholder = canChoose && !periods.length ? 'Période non disponible' : 'Sélectionner la période';
      this.replaceOptions(this.year, placeholder, periods);
      this.year.disabled = !canChoose || !periods.length;
      if (reset || !periods.some(period => period.key === this.year.value)) this.year.value = '';
      this.year.pfRebuild?.();
    }

    setMode(mode) {
      if (!['guided', 'identity'].includes(mode)) return;
      this.mode = mode;
      $$('[data-vehicle-mode]', this).forEach(button => {
        const active = button.dataset.vehicleMode === mode;
        button.setAttribute('aria-selected', String(active));
      });
      $$('[data-vehicle-panel]', this).forEach(panel => {
        panel.hidden = panel.dataset.vehiclePanel !== mode;
      });
      const rememberField = this.remember?.closest('.vehicle-finder__remember');
      if (rememberField) rememberField.hidden = mode !== 'guided';
      this.hideError();
    }

    hideError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }

    fail(message, target) {
      if (this.error) {
        this.error.textContent = message;
        this.error.hidden = false;
      }
      const visibleControl = target?.closest?.('.pf-select')?.querySelector('.pf-select__trigger') || target;
      visibleControl?.focus();
      announce(message);
    }

    submit() {
      this.hideError();
      let vehicle = {};
      let vehicleSummary = '';
      let searchTerms = [];
      if (this.mode === 'guided') {
        if (!this.brand?.value) return this.fail('Sélectionnez la marque du véhicule.', this.brand);
        if (!this.model?.value) return this.fail('Sélectionnez le modèle du véhicule.', this.model);
        const modelPeriods = this.currentModel()?.periods || [];
        if (modelPeriods.length && !this.year?.value) return this.fail('Sélectionnez la période de production du véhicule.', this.year);
        const brandLabel = this.selectedText(this.brand);
        const modelLabel = this.selectedText(this.model);
        const periodLabel = modelPeriods.length ? this.selectedText(this.year) : 'Période non renseignée';
        vehicle = {
          mode: 'guided',
          brand: this.brand.value,
          brandLabel,
          model: modelLabel,
          modelKey: this.model.value,
          period: periodLabel,
          periodKey: this.year.value
        };
        vehicleSummary = `${vehicle.brandLabel} ${vehicle.model} · ${vehicle.period}`;
        searchTerms = [vehicle.brandLabel, vehicle.model, modelPeriods.length ? vehicle.period : ''];
        if (this.remember?.checked) this.saveVehicle(vehicle);
      } else {
        const plate = this.plate?.value.trim() || '';
        const vin = this.vin?.value.trim() || '';
        if (!plate && !vin) return this.fail('Saisissez une immatriculation ou un numéro VIN.', this.plate);
        if (vin && vin.length !== 17) return this.fail('Le numéro VIN doit comporter exactement 17 caractères.', this.vin);
        vehicle = { mode: 'identity', plate, vin };
        vehicleSummary = plate ? `Immatriculation ${plate}` : `VIN ${vin}`;
      }

      $('[data-vehicle-summary]', this)?.replaceChildren(document.createTextNode(vehicleSummary));

      const searchLink = $('[data-vehicle-search]', this);
      const usableSearchTerms = searchTerms.filter(Boolean);
      if (searchLink) {
        const canSearch = this.mode === 'guided';
        searchLink.hidden = !canSearch;
        if (canSearch) {
          const searchUrl = new URL(this.dataset.searchUrl || '/search', window.location.origin);
          searchUrl.searchParams.set('q', usableSearchTerms.join(' '));
          searchUrl.searchParams.set('type', 'product');
          searchUrl.searchParams.set('options[prefix]', 'last');
          searchUrl.searchParams.set('univers', 'carrosserie');
          searchLink.href = `${searchUrl.pathname}${searchUrl.search}`;
        }
      }

      const message = [
        'Bonjour, je souhaite vérifier les pièces carrosserie compatibles avec ce véhicule.',
        `Véhicule : ${vehicleSummary}`,
        this.mode === 'identity' && vehicle.vin ? `VIN : ${vehicle.vin}` : '',
        'Pouvez-vous identifier le véhicule et m’aider dans ma recherche ?'
      ].filter(Boolean).join('\n');
      const whatsapp = $('[data-vehicle-whatsapp]', this);
      if (whatsapp) whatsapp.href = `https://wa.me/${this.dataset.whatsappNumber || ''}?text=${encodeURIComponent(message)}`;

      if (this.result) {
        this.result.hidden = false;
        requestAnimationFrame(() => this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
      }
      announce('Votre véhicule a été identifié.');
    }

    saveVehicle(vehicle) {
      const identity = this.vehicleIdentity(vehicle);
      const existingIndex = this.garage.findIndex(item => this.vehicleIdentity(item) === identity);
      if (existingIndex >= 0) {
        this.garage.splice(existingIndex, 1);
        this.garage.unshift(vehicle);
        this.persistGarage();
        this.renderGarage();
        announce('Le véhicule enregistré a été actualisé.');
        return true;
      }
      if (this.garage.length >= this.garageLimit) {
        this.openGarage();
        if (this.garageLimitLabel) this.garageLimitLabel.textContent = 'Garage complet · supprimez un véhicule pour libérer une place';
        announce('Votre garage est complet. Supprimez un véhicule avant d’en ajouter un autre.');
        return false;
      }
      this.garage.unshift(vehicle);
      this.persistGarage();
      this.renderGarage();
      announce(`${vehicle.brandLabel} ${vehicle.model} a été ajouté à votre garage.`);
      return true;
    }

    vehicleIdentity(vehicle) {
      return [
        vehicle?.brand && vehicle.brand !== 'other' ? vehicle.brand : this.normalizeCatalogKey(vehicle?.brandLabel),
        vehicle?.modelKey && vehicle.modelKey !== 'other' ? vehicle.modelKey : this.normalizeCatalogKey(vehicle?.model),
        vehicle?.periodKey && vehicle.periodKey !== 'other' ? vehicle.periodKey : this.normalizeCatalogKey(vehicle?.period || vehicle?.year)
      ].join('|');
    }

    isValidGarageVehicle(vehicle) {
      return vehicle?.mode === 'guided'
        && vehicle.brand
        && vehicle.brand !== 'other'
        && vehicle.model
        && vehicle.modelKey !== 'other'
        && vehicle.periodKey !== 'other'
        && (vehicle.period || vehicle.year);
    }

    loadGarage() {
      try {
        const savedGarage = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
        this.garage = Array.isArray(savedGarage)
          ? savedGarage.filter(vehicle => this.isValidGarageVehicle(vehicle)).slice(0, this.garageLimit)
          : [];
        if (!this.garage.length) {
          const legacyVehicle = JSON.parse(window.localStorage.getItem(this.legacyStorageKey) || 'null');
          if (this.isValidGarageVehicle(legacyVehicle)) {
            this.garage = [legacyVehicle];
            this.persistGarage();
            window.localStorage.removeItem(this.legacyStorageKey);
          }
        }
      } catch {
        this.garage = [];
      }
      this.renderGarage();
    }

    persistGarage() {
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(this.garage.slice(0, this.garageLimit)));
      } catch {}
    }

    renderGarage() {
      if (this.garageCount) this.garageCount.textContent = String(this.garage.length);
      if (this.garageEmpty) this.garageEmpty.hidden = this.garage.length > 0;
      if (this.garageLimitLabel) {
        const remaining = Math.max(0, this.garageLimit - this.garage.length);
        this.garageLimitLabel.textContent = remaining
          ? `${remaining} emplacement${remaining > 1 ? 's' : ''} disponible${remaining > 1 ? 's' : ''}`
          : 'Garage complet · 5 véhicules enregistrés';
      }
      if (!this.garageList) return;
      this.garageList.replaceChildren();
      this.garage.forEach((vehicle, index) => {
        const item = document.createElement('li');
        const number = document.createElement('span');
        number.className = 'vehicle-finder__garage-number';
        number.textContent = String(index + 1).padStart(2, '0');

        const identity = document.createElement('div');
        const name = document.createElement('strong');
        name.textContent = `${vehicle.brandLabel} ${vehicle.model}`;
        const period = document.createElement('span');
        period.textContent = vehicle.period || vehicle.year;
        identity.append(name, period);

        const actions = document.createElement('div');
        actions.className = 'vehicle-finder__garage-actions';
        const useButton = document.createElement('button');
        useButton.type = 'button';
        useButton.dataset.garageUse = String(index);
        useButton.textContent = 'Utiliser';
        const deleteButton = document.createElement('button');
        deleteButton.type = 'button';
        deleteButton.className = 'pf-close-button pf-close-button--compact vehicle-finder__garage-delete';
        deleteButton.dataset.garageDelete = String(index);
        deleteButton.setAttribute('aria-label', `Supprimer ${vehicle.brandLabel} ${vehicle.model} du garage`);
        deleteButton.textContent = '×';
        actions.append(useButton, deleteButton);
        item.append(number, identity, actions);
        this.garageList.appendChild(item);
      });
    }

    toggleGarage() {
      if (this.garagePanel?.hidden) this.openGarage();
      else this.closeGarage(true);
    }

    openGarage() {
      if (!this.garagePanel) return;
      this.garagePanel.hidden = false;
      this.garageToggle?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.garageClose?.focus());
    }

    closeGarage(restoreFocus = false) {
      if (!this.garagePanel) return;
      this.garagePanel.hidden = true;
      this.garageToggle?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.garageToggle?.focus();
    }

    removeVehicle(index) {
      if (!Number.isInteger(index) || !this.garage[index]) return;
      const [removed] = this.garage.splice(index, 1);
      this.persistGarage();
      this.renderGarage();
      announce(`${removed.brandLabel} ${removed.model} a été supprimé de votre garage.`);
    }

    restoreVehicle(vehicle) {
      try {
        if (!vehicle) return;
        this.setMode('guided');
        this.brand.value = vehicle.brand;
        if (!this.brand.value) this.brand.value = this.normalizeCatalogKey(vehicle.brandLabel);
        this.brand.dispatchEvent(new Event('change', { bubbles: true }));
        this.model.value = vehicle.modelKey || this.normalizeCatalogKey(vehicle.modelOption || vehicle.model);
        if (!this.model.value) return this.fail('Ce modèle n’est plus disponible dans le référentiel.', this.model);
        this.model.dispatchEvent(new Event('change', { bubbles: true }));
        this.year.value = vehicle.periodKey || this.normalizeCatalogKey(vehicle.period || vehicle.year);
        if (!this.year.value && this.currentModel()?.periods?.length) {
          return this.fail('Cette période n’est plus disponible dans le référentiel.', this.year);
        }
        this.year.dispatchEvent(new Event('change', { bubbles: true }));
        this.closeGarage();
        if (this.result) this.result.hidden = true;
        const brandControl = this.brand?.closest('.pf-select')?.querySelector('.pf-select__trigger') || this.brand;
        brandControl?.focus();
        announce(`Véhicule restauré : ${vehicle.brandLabel} ${vehicle.model}`);
      } catch {}
    }
  }
  customElements.define('pf-vehicle-finder', VehicleFinder);

  class UniverseGateway extends HTMLElement {
    connectedCallback() {
      if (this.dataset.universeReady === 'true') return;
      this.dataset.universeReady = 'true';
      this.allowed = ['consommables', 'carrosserie', 'mecanique'];
      this.labels = {
        consommables: 'Consommables',
        carrosserie: 'Pièces carrosserie',
        mecanique: 'Pièces mécaniques'
      };
      this.indexLabels = {
        consommables: 'PF / CONSOMMABLES',
        carrosserie: 'PF / CARROSSERIE',
        mecanique: 'PF / MÉCANIQUE'
      };
      this.splash = $('[data-universe-splash]', this);
      this.warning = $('[data-universe-warning]', this);
      this.panels = $$('[data-universe-panel]', this);
      this.storageKey = this.dataset.storageKey || 'profinish.universe';
      this.lastFocus = null;
      this.isTransitioning = false;

      const params = new URLSearchParams(window.location.search);
      const requested = params.get('univers');
      const forceChoice = params.has('choix-univers');
      const isRootArrival = window.location.pathname === (window.theme?.routes?.root || '/') && !requested;
      const stored = this.readStoredChoice();
      const hasValidRequested = this.allowed.includes(requested);
      const initial = hasValidRequested
        ? requested
        : this.allowed.includes(stored)
          ? stored
          : this.dataset.defaultUniverse || 'consommables';

      this.select(initial, hasValidRequested);
      $$('[data-universe-choice]', this).forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.isTransitioning) return;
          const universe = link.dataset.universeChoice;
          this.animateSelection(link, () => {
            if (universe === 'consommables') {
              this.select(universe, true);
              this.setUniverseUrl(universe);
              this.close();
            } else {
              this.showWarning(universe);
            }
          });
        });
      });
      $$('[data-universe-confirm]', this).forEach(button => {
        button.addEventListener('click', () => {
          const universe = button.dataset.universeConfirm;
          this.select(universe, true);
          this.setUniverseUrl(universe);
          this.close();
        });
      });
      $('[data-universe-back]', this)?.addEventListener('click', () => this.backToSplash());
      $$('[data-universe-open]', this).forEach(button => button.addEventListener('click', () => this.open()));
      $$('[data-universe-link]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        document.getElementById('MobileMenu')?.close();
        this.open();
      }));
      this.addEventListener('keydown', event => {
        const activeDialog = this.warning && !this.warning.hidden
          ? this.warning
          : this.splash && !this.splash.hidden
            ? this.splash
            : null;
        if (!activeDialog) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          if (activeDialog === this.warning) {
            this.backToSplash();
          } else if (this.readStoredChoice()) {
            this.close();
          }
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = $$('button:not([disabled]),a[href]', activeDialog).filter(item => item.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      this.handlePopState = () => {
        const universe = new URLSearchParams(window.location.search).get('univers');
        if (this.allowed.includes(universe)) {
          this.select(universe, true);
          this.close();
        } else {
          this.select(this.readStoredChoice() || this.dataset.defaultUniverse || 'consommables', false);
          if (window.location.pathname === (window.theme?.routes?.root || '/')) this.open();
        }
      };
      window.addEventListener('popstate', this.handlePopState);

      if (forceChoice || isRootArrival) this.open();
      if (forceChoice) {
        params.delete('choix-univers');
        const cleanQuery = params.toString();
        window.history.replaceState({}, '', `${window.location.pathname}${cleanQuery ? `?${cleanQuery}` : ''}${window.location.hash}`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.handlePopState);
      clearTimeout(this.splashIntroTimer);
      clearTimeout(this.selectionTimer);
    }

    readStoredChoice() {
      try { return window.localStorage.getItem(this.storageKey); } catch { return null; }
    }

    select(universe, persist = true) {
      if (!this.allowed.includes(universe)) return;
      document.documentElement.dataset.pfUniverse = universe;
      this.panels.forEach(panel => {
        const active = panel.dataset.universePanel === universe;
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      $$('[data-current-universe]').forEach(label => {
        label.textContent = this.labels[universe];
      });
      $$('[data-universe-index]').forEach(label => {
        label.textContent = this.indexLabels[universe];
      });
      if (persist) {
        try { window.localStorage.setItem(this.storageKey, universe); } catch {}
      }
      document.dispatchEvent(new CustomEvent('profinish:universe-change', { detail: { universe } }));
      announce(`Univers sélectionné : ${this.labels[universe]}`);
    }

    setUniverseUrl(universe) {
      const url = new URL(window.location.href);
      url.searchParams.set('univers', universe);
      url.searchParams.delete('choix-univers');
      window.history.pushState({ universe }, '', `${url.pathname}?${url.searchParams.toString()}${url.hash}`);
    }

    playSplashIntro() {
      if (!this.splash) return;
      clearTimeout(this.splashIntroTimer);
      this.splash.classList.remove('is-entering');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      void this.splash.offsetWidth;
      this.splash.classList.add('is-entering');
      this.splashIntroTimer = window.setTimeout(() => {
        this.splash?.classList.remove('is-entering');
      }, 1600);
    }

    resetSelectionAnimation() {
      clearTimeout(this.selectionTimer);
      this.isTransitioning = false;
      this.splash?.classList.remove('is-selecting');
      $$('[data-universe-choice]', this.splash).forEach(choice => {
        choice.classList.remove('is-selected', 'is-dismissed', 'is-dismissed-before', 'is-dismissed-after');
        choice.removeAttribute('aria-busy');
        const badge = $('.universe-choice__availability', choice);
        if (badge?.dataset.selectionOriginal) {
          badge.textContent = badge.dataset.selectionOriginal;
          delete badge.dataset.selectionOriginal;
        }
        choice.style.removeProperty('--pf-selection-card-transform');
      });
      this.splash?.style.removeProperty('--pf-selection-dx');
      this.splash?.style.removeProperty('--pf-selection-dy');
      this.splash?.style.removeProperty('--pf-selection-scale');
      this.splash?.style.removeProperty('--pf-selection-origin-x');
      this.splash?.style.removeProperty('--pf-selection-origin-y');
      $$('.universe-sand-layer', this.splash).forEach(layer => layer.remove());
    }

    createSandFlow(source, direction) {
      if (!this.splash || !source) return;
      const bounds = source.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

      const layer = document.createElement('span');
      const palette = source.classList.contains('universe-choice--active')
        ? ['#168dff', '#65c8ff', '#d8e7f1', '#263b4c', '#0b1721']
        : ['#8b99a4', '#63727e', '#d0d8de', '#31404b', '#15212a'];
      layer.className = 'universe-sand-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.style.top = `${bounds.top}px`;
      layer.style.left = `${bounds.left}px`;
      layer.style.width = `${bounds.width}px`;
      layer.style.height = `${bounds.height}px`;

      for (let index = 0; index < 58; index += 1) {
        const grain = document.createElement('i');
        const x = (index * 37 + Math.floor(index / 6) * 11) % 100;
        const y = (index * 61 + Math.floor(index / 7) * 17) % 96;
        const size = 2 + (index * 7) % 6;
        const delay = y / 250 + (index % 5) * 0.012;
        const duration = 0.56 + (index % 7) * 0.055;
        const drift = direction * (20 + (index % 8) * 5) + ((index % 3) - 1) * 9;
        const fall = 58 + (index % 9) * 11;
        const rotation = (index % 2 ? 1 : -1) * (100 + (index % 6) * 34);
        grain.style.left = `${x}%`;
        grain.style.top = `${y}%`;
        grain.style.width = `${size}px`;
        grain.style.height = `${Math.max(2, size * 0.7)}px`;
        grain.style.background = palette[index % palette.length];
        grain.style.setProperty('--pf-grain-delay', `${delay.toFixed(3)}s`);
        grain.style.setProperty('--pf-grain-duration', `${duration.toFixed(3)}s`);
        grain.style.setProperty('--pf-grain-drift', `${drift}px`);
        grain.style.setProperty('--pf-grain-fall', `${fall}px`);
        grain.style.setProperty('--pf-grain-rotate', `${rotation}deg`);
        layer.append(grain);
      }
      this.splash.append(layer);
    }

    animateSelection(choice, callback) {
      if (!this.splash || !choice || this.isTransitioning) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        callback();
        return;
      }

      this.isTransitioning = true;
      clearTimeout(this.splashIntroTimer);
      this.splash.classList.remove('is-entering');
      this.splash.classList.add('is-selecting');
      const choices = $$('[data-universe-choice]', this.splash);
      const selectedIndex = choices.indexOf(choice);
      const bounds = choice.getBoundingClientRect();
      const shell = $('.universe-splash__shell', this.splash);
      const shellBounds = shell?.getBoundingClientRect();
      const centerX = bounds.left + bounds.width / 2;
      const centerY = bounds.top + bounds.height / 2;
      const coverScale = Math.max(
        window.innerWidth / Math.max(bounds.width, 1),
        window.innerHeight / Math.max(bounds.height, 1)
      ) * 1.18;
      this.splash.style.setProperty('--pf-selection-dx', `${window.innerWidth / 2 - centerX}px`);
      this.splash.style.setProperty('--pf-selection-dy', `${window.innerHeight / 2 - centerY}px`);
      this.splash.style.setProperty('--pf-selection-scale', coverScale.toFixed(3));
      if (shellBounds) {
        this.splash.style.setProperty('--pf-selection-origin-x', `${centerX - shellBounds.left}px`);
        this.splash.style.setProperty('--pf-selection-origin-y', `${centerY - shellBounds.top}px`);
      }
      const frozenTransform = window.getComputedStyle(choice).transform;
      choice.style.setProperty('--pf-selection-card-transform', frozenTransform === 'none' ? 'none' : frozenTransform);
      choices.forEach((item, index) => {
        const selected = item === choice;
        if (!selected) this.createSandFlow(item, index < selectedIndex ? -1 : 1);
        item.classList.toggle('is-selected', selected);
        item.classList.toggle('is-dismissed', !selected);
        item.classList.toggle('is-dismissed-before', !selected && index < selectedIndex);
        item.classList.toggle('is-dismissed-after', !selected && index > selectedIndex);
        if (selected) {
          item.setAttribute('aria-busy', 'true');
          const badge = $('.universe-choice__availability', item);
          if (badge) {
            badge.dataset.selectionOriginal = badge.textContent;
            badge.textContent = 'Ouverture de l’univers…';
          }
        }
      });

      this.selectionTimer = window.setTimeout(() => {
        callback();
        this.resetSelectionAnimation();
      }, 2400);
    }

    open() {
      document.documentElement.classList.remove('pf-universe-direct');
      if (!this.splash) {
        document.documentElement.classList.remove('pf-universe-pending');
        return;
      }
      this.resetSelectionAnimation();
      this.lastFocus = document.activeElement;
      if (this.warning) this.warning.hidden = true;
      this.splash.hidden = false;
      document.documentElement.classList.remove('pf-universe-pending');
      this.playSplashIntro();
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => {
        $('[data-universe-choice]', this.splash)?.focus();
      });
    }

    showWarning(universe) {
      if (!this.warning || !this.allowed.includes(universe) || universe === 'consommables') return;
      this.splash.hidden = true;
      this.warning.hidden = false;
      $$('[data-warning-panel]', this.warning).forEach(panel => {
        panel.hidden = panel.dataset.warningPanel !== universe;
      });
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => $(`[data-warning-panel="${universe}"] a[href]`, this.warning)?.focus());
    }

    backToSplash() {
      if (this.warning) this.warning.hidden = true;
      if (this.splash) this.splash.hidden = false;
      this.resetSelectionAnimation();
      this.playSplashIntro();
      requestAnimationFrame(() => $('[data-universe-choice]', this.splash)?.focus());
    }

    close() {
      if (!this.splash) return;
      this.splash.hidden = true;
      if (this.warning) this.warning.hidden = true;
      this.resetSelectionAnimation();
      document.body.classList.remove('is-locked');
      this.lastFocus?.focus?.();
    }
  }
  customElements.define('pf-universe-gateway', UniverseGateway);
})();
